/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuRadioSelectSearch_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterLocation_viewer$ref: FragmentReference;
export type SbSharedRefineMenuFilterLocation_viewer = {|
  +$fragmentRefs: SbSharedRefineMenuRadioSelectSearch_viewer$ref,
  +$refType: SbSharedRefineMenuFilterLocation_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterLocation_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuRadioSelectSearch_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '81a8f589363e416af0c7d20c7b6777ea';
module.exports = node;
